import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import LoginForm from '../../components/LoginForm/LoginForm';

import FormContainer from 'components/UI/FormContainer/FormContainer';

import { academyDataActions } from 'store/academy-slice';

import classes from './Login.module.css';

const url = window.location.pathname.split('/');

const Login = () => {
  const { t } = useTranslation(['login']);
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);
  const dataUser = useSelector(state => state.userInfo);

  useEffect(() => {
    ReactGA.initialize(
      [
        {
          trackingId: 'G-5883QCZJX8',
          gaOptions: {
            name: 'trackerMayahii'
          }
        },
        {
          trackingId: `${dataAcademy.data.analitycs}`,
          gaOptions: { name: 'trackerUser' }
        }
      ],
      { debug: false }
    );

    ReactGA.send({
      hitType: 'pageview',
      page: `/${dataAcademy.data.shortName}/login`,
      title: `/${dataAcademy.data.shortName}/login`
    });
  }, [dataAcademy]);

  useEffect(() => {
    if (dataUser.data.usuario) {
      window.location.href = `/${dataAcademy.data.shortName}`;
    }
  }, [dataUser.data]);

  useEffect(() => {
    dispatch(
      academyDataActions.showBanner({
        showBanner: true
      })
    );
  }, []);

  return (
    <>
      {dataAcademy.data.hasLogin !== 1 ? (
        <FormContainer
          title={t('principal_text')}
          btnLink="register"
          login
        >
          <LoginForm />
        </FormContainer>
      ) : (
        <div className={classes.btnContainer}>
          <Button
            component="a"
            href={`https://admincursos.tec.mx/bridge/api/authenticate?callback=${url[1]}/${dataAcademy.data.idAcademy}`}
            raised
            variant="contained"
            className={classes.btnSSO}
            color="primary"
          >
            Iniciar sesión con el Tec
          </Button>
        </div>
      )}
    </>
  );
};

export default Login;
